export default {
    it: { 
        label: "Italiano",
        flag: 'it'
    },
    en: {
        label: "English",
        flag: 'gb'
    }
};